import { render, staticRenderFns } from "./ZboxClosures.vue?vue&type=template&id=3b005890&scoped=true&"
import script from "./ZboxClosures.vue?vue&type=script&lang=js&"
export * from "./ZboxClosures.vue?vue&type=script&lang=js&"
import style0 from "./ZboxClosures.vue?vue&type=style&index=0&id=3b005890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b005890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
